import { render, staticRenderFns } from "./UserProfileSocial.vue?vue&type=template&id=7634ef4a&"
import script from "./UserProfileSocial.vue?vue&type=script&lang=js&"
export * from "./UserProfileSocial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports